import React, { Fragment, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Splitter } from "@progress/kendo-react-layout";
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import { Checkbox } from "@progress/kendo-react-inputs";
import { Toolbar, ToolbarItem, ToolbarSeparator, ToolbarSpacer,Button, DropDownButton } from "@progress/kendo-react-buttons";
import { Loader } from "@progress/kendo-react-indicators";
import { DropDownListById } from "../../forms/form-components";
import { Form } from "../../components/form";
import { List } from "../../components/list";
import { Input } from "@progress/kendo-react-inputs";
import { DataSourcesPageForm } from "./datasourcespageform";
import { getDataSourceIcon } from "../../lib/utils";
import { IntroPage } from "../intropage";
import { HelpPage } from "../helppage";
import { ReactComponent as TableIcon } from  "../../icons/table.svg";
import { ReactComponent as DatabaseIcon } from  "../../icons/database.svg";
import { ReactComponent as AggregateIcon } from  "../../icons/aggregate.svg";
import { ReactComponent as LockIcon } from  "../../icons/folderlock.svg";
import { ReactComponent as GroupIcon } from  "../../icons/layergroup.svg";
import { ReactComponent as ValueTableIcon } from  "../../icons/dialpad.svg";
import { ReactComponent as ValueIcon } from  "../../icons/desktop.svg";
import { ReactComponent as CompleteIcon } from  "../../icons/ellipsish.svg";
import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { canCreateResolvedDataSources, canDeleteResolvedDataSources, canEditResolvedDataSources, canViewResolvedDataSources, dataSourceMaxReached } from "../../routing/authorizationhandlers";


const datasetItemRender = (li, itemProps) => {
  let itemIcon = "";

  if (itemProps.dataItem.CategoryId == 1)//table
      itemIcon = "grid";
  else if (itemProps.dataItem.CategoryId == 2)//view
      itemIcon = "group";
  else if (itemProps.dataItem.CategoryId == 3)//SP
      itemIcon = "html";
    else //"none"
      itemIcon = "minus";

  const itemChildren = (
    <div className="datasets-list-item" style={{ display: "flex", alignItems:"center", padding: "0px 6px" }}>
      <div
        style={{
          marginRight: 12
        }}
        className={`k-icon k-i-${itemIcon}`}
      ></div>
      <div>{itemProps.dataItem.Title}</div>
    </div>
  );

  return React.cloneElement(li, li.props, itemChildren);
};

const toolbarRenderer = (props) => {
  const { currentTheme, currentUser, pageState, t } = props;

  const saveTitle = pageState.mode == 1 ? t("datasources.save") : t("datasources.update");

  const toolsVisibleIcon = pageState.toolsVisible ? "unpin" : "pin";
  const toolsVisibleTitle = pageState.toolsVisible ? t("datasources.hide") : t("datasources.show");

  return (
    <Toolbar>
      <ToolbarItem>
        <Button
          disabled={pageState.processing}
          style={{ color: currentTheme.primary }}
          
          icon={toolsVisibleIcon}
          onClick={props.onToolsToggle}
        >
          {toolsVisibleTitle}
        </Button>
      </ToolbarItem>
      <ToolbarSeparator/>
      {
        currentUser.IsAuthenticated && canCreateResolvedDataSources(currentUser) &&
        <ToolbarItem>
          <Button disabled={pageState.processing ||dataSourceMaxReached(currentUser)} style={{color: currentTheme.primary}}   icon="plus" onClick={props.onNew}>
            {t("datasources.create")}

          </Button>
      </ToolbarItem>     
      }            
      {        
        !pageState.formValues.IsSystem && currentUser.IsAuthenticated && 
        (
          (pageState.mode == 1 && canCreateResolvedDataSources(currentUser))  
          ||
          (pageState.mode == 2 && canEditResolvedDataSources(currentUser))  
        ) &&        
        <Fragment>
          <ToolbarSeparator/>
          <ToolbarItem>
            <Button disabled={pageState.processing || (pageState.mode == 1 && dataSourceMaxReached(currentUser))} style={{color: currentTheme.primary}}  icon="save" onClick={props.onSave}>
              {saveTitle}
            </Button>
          </ToolbarItem>
        </Fragment>
      }
      {
        pageState.mode == 2 && currentUser.IsAuthenticated && canCreateResolvedDataSources(currentUser) && canViewResolvedDataSources(currentUser) &&
        <Fragment>
            <ToolbarSeparator/>
            <ToolbarItem>
                <Button disabled={pageState.processing || dataSourceMaxReached(currentUser)} style={{color: currentTheme.primary}}   icon="backward-element" onClick={props.onClone}>
                    {t("datasources.clone")}

                </Button>
            </ToolbarItem>
        </Fragment>
      } 
      {        
        !pageState.formValues.IsSystem && pageState.mode == 2 && currentUser.IsAuthenticated && canDeleteResolvedDataSources(currentUser) &&  
        <Fragment>
          <ToolbarSeparator/>
          <ToolbarItem>
            <Button disabled={pageState.processing} style={{color: currentTheme.primary}}  icon="delete" onClick={e => props.onDelete(null)}>
              {t("datasources.delete2")}
            </Button>
          </ToolbarItem>
        </Fragment>
      }
    </Toolbar>
  );
};

const getEntityOperations = (expression, currentUser, t) => {
  let result = [];

  if (expression.IsSystem)
  {
 
    if (currentUser.IsAuthenticated && (canViewResolvedDataSources(currentUser) || canEditResolvedDataSources(currentUser)))
       result.push({id:1, text:t("datasources.view"), icon: "eye"});
  }
  else
  {
  
    if (currentUser.IsAuthenticated && (canViewResolvedDataSources(currentUser) || canEditResolvedDataSources(currentUser)))
      result.push({id:2, text:t("datasources.view"), icon:"eye"}); 
 
 
    if (currentUser.IsAuthenticated && canDeleteResolvedDataSources(currentUser))
      result.push({id:3, text:t("datasources.delete3"), icon: "delete"}); 
  }

  return result;
};

const entityMenuItemRenderer = (currentTheme, entityId, onItemClicked) => props => {
  if (props.item.text)
    return (
      <div style={{display: "flex", width: "100%", padding: "0px 6px"}} onClick={e => onItemClicked(entityId, props.item)}>
        <span className={`k-icon k-i-${props.item.icon}`} style={{display: "inline-block"}}></span>
        <div style={{marginLeft:12}}>{props.item.text}</div>
      </div>
    );
  else
      return (<div className="menu-separator" style={{}}/>);
};

const entitiesItemRenderer = (currentTheme, currentUser, t) => (props, item, index) => {
  const icon = getDataSourceIcon(item.TypeId);

  return (            
    <div key={item.Id} className={`list-item`} onDoubleClick={e=>{
      if (currentUser.IsAuthenticated && (canViewResolvedDataSources(currentUser) || canEditResolvedDataSources(currentUser)))
        props.onEntityDoubleClick(item.Id)
      }}>
      <div className={`list-item-datasource-icon k-icon ${icon}`}></div>
      <div className="list-item-title">{item.Title}</div>
      {
        currentUser.IsAuthenticated && (canViewResolvedDataSources(currentUser)  || canEditResolvedDataSources(currentUser) || canDeleteResolvedDataSources(currentUser)) &&
        <div className="list-item-operations">
          <DropDownButton
            className="buttons-container-button"
            items={getEntityOperations(item, currentUser, t)}
            itemRender={entityMenuItemRenderer(currentTheme, item.Id, (entityId, _item) =>{
              if (_item.id == 1 || _item.id == 2)//view            
                props.onEntitySelected(entityId, _item);
              else if (_item.id == 3)// delete
                props.onDelete(entityId, _item);
            })}
            icon="more-horizontal"
            fillMode={"flat"}
          />
        </div>     
      }      
  </div>          
  );
}

export const DataSourcesPageBody = props => 
{
    const {
        onSplitterChange,
        dataSetsPanelRef, onDatasetChange, 
        onNew, onSave, onClone, onDelete,         
        onErrorbarClose, onToolsToggle,
        onEntitySelected, onEntityDoubleClick,
        updateDirtyState,
        ...other
    } = props;    

    const currentTheme = useSelector(state => state.currentTheme);
    const currentUser = useSelector(state => state.currentUser);
    const pageState = useSelector(state => state.dataSourcesPage);    
    const appearance = useSelector(state => state.appearance);    
    const datasets = pageState.lookups.datasets;
    const currentDataset = pageState.currentDataset;
    const currentDatasetId = currentDataset.Id;
    const [entityFilter, setEntityFilter] = useState("");
    const [showSystemEntities, setShowSystemEntities] = useState(true);
    const { t } = useTranslation();


    const introItems = useMemo(() => [
      {color: currentTheme.colorVariant1, icon: DatabaseIcon, width:64, height: 32, content: t("datasources.intro_database")},
      {color: currentTheme.colorVariant2, icon: ValueTableIcon, width:90, height: 32, content: t("datasources.intro_valuetable")},
      {color: currentTheme.colorVariant2, icon: ValueIcon, width:100, height: 32, content: t("datasources.intro_value")},
      {color: currentTheme.colorVariant3, icon: TableIcon, width:80, height: 32, content: t("datasources.intro_table")},
      {color: currentTheme.colorVariant3, icon: LockIcon, width:90, height: 32, content: t("datasources.intro_lock")},
      {color: currentTheme.colorVariant3, icon: AggregateIcon, width:90, height: 32, content: t("datasources.intro_aggregate")},
      {color: currentTheme.colorVariant3, icon: GroupIcon, width:90, height: 32, content: t("datasources.intro_group")},
      {color: currentTheme.colorVariant3, icon: CompleteIcon, width:90, height: 32, content: t("datasources.intro_complete")},
    ], [t, currentTheme]); 

    const helpItems = useMemo(() => [
      {color: currentTheme.colorVariant1, icon: DatabaseIcon, width:60, height: 54, content: t("datasources.help_database")},
      {color: currentTheme.colorVariant2, icon: ValueTableIcon, width:70, height: 64, content: t("datasources.help_valuetable")},
      {color: currentTheme.colorVariant2, icon: ValueIcon, width:70, height: 64, content: t("datasources.help_value")},
      {color: currentTheme.colorVariant3, icon: TableIcon, width:70, height: 64, content: t("datasources.help_table")},
      {color: currentTheme.colorVariant3, icon: LockIcon, width:70, height: 64, content: t("datasources.help_lock")},
    ], [t, currentTheme]); 


    const getPanelBarItems = () =>{
      const panelBarItems = [];     

      panelBarItems.push(
        <PanelBarItem className="panel-dataset" key="dataset" title= {t("datasources.dataset")} expanded={true}>
          <div className="dataset">
            <DropDownListById  iconClassName="k-icon k-i-arrow-s k-i-table" style={{marginTop: 4}} 
              data={datasets} dataItemKey="Id" textField="Title" value={currentDatasetId} onChange={onDatasetChange}
              itemRender={datasetItemRender}/>                            
            {
              currentDatasetId == 0 && 
              <div style={{marginLeft:3, color:`${currentTheme.touchColor}`}} className="k-form-hint k-text-center">
                {t("datasources.select")}
              </div>
            }
          </div>
        </PanelBarItem>
        );
    
        if (currentDataset.Id > 0)
        {
          panelBarItems.push(
          <PanelBarItem className="panel-entities" key="dataSources" title={t("datasources.datasources")} selected={false} expanded={false} >
            <div style={{display: "flex", flexDirection: "column"}}>
              <Input type="search" value={entityFilter} onChange={e => setEntityFilter(e.value)} 
                        style={{width: "calc(100% - 16px)", margin: "16px 8px 8px 8px", backgroundColor: "transparent"}} placeholder={t("datasources.search")}
              />
              <div style={{marginTop: 2, marginBottom: 16, marginLeft: 10}}>
                <Checkbox style={{marginTop: -4, marginRight: 4}} value={showSystemEntities} onChange={e => {
                    setShowSystemEntities(e.value);
                }}> {t("datasources.show_data")}</Checkbox>
              </div>
              <List className="datasources" items={currentDataset.DataSources.filter(e => {                
                if ((!entityFilter || entityFilter.trim() == "") && showSystemEntities)
                  return true;
              
                if ((!entityFilter || entityFilter.trim() == ""))//do not show system entities
                  return e.IsSystem == false;
              
                //i am here => there is text
                const filter = entityFilter.toLowerCase();

                if (showSystemEntities)
                    return e.Title.toLowerCase().indexOf(filter) >= 0;
                else
                    return e.Title.toLowerCase().indexOf(filter) >= 0 && e.IsSystem == false;
              })} itemRenderer={entitiesItemRenderer(currentTheme, currentUser, t)} 
                  onEntitySelected={onEntitySelected} onEntityDoubleClick={onEntityDoubleClick} onDelete={onDelete} />
            </div>
          </PanelBarItem>
          );       
    
          panelBarItems.push(
            <PanelBarItem className="panel-description" key="help" title={t("datasources.description")} selected={false} expanded={false} style={{}}>
              <p className="description" style={{padding: "6px 12px", margin: 0}}>{currentDataset.Description}</p>
            </PanelBarItem>
          );
        }

        return panelBarItems;
    };

    return (
            <Fragment>
              {
                pageState.processing && 
                <div className="page-loader">
                  <Loader size={"large"} type="infinite-spinner" themeColor={"primary"} />
                  {
                    pageState.processingText && 
                    <div style={{fontSize: 13, color: currentTheme.primary}}>{pageState.processingText}</div>
                  }
                </div>
              }
              {
                pageState.pageLoaded && 
                <Splitter style={{border: "none"}} panes={pageState.panes} onChange={onSplitterChange}>                   
                  <div className="datasources-page-manager">
                    <PanelBar ref={dataSetsPanelRef} style={{border: "none"}} expanded={[ ".0", ".1", ".2"]}>
                      {getPanelBarItems()}
                    </PanelBar>
                  </div>
                  {
                    currentDatasetId > 0 &&
                    <Form className="datasources-page-form" currentTheme={currentTheme} currentUser={currentUser}
                        toolbarRenderer={toolbarRenderer} t={t} onNew={onNew} onSave={onSave} onClone={onClone} onDelete={onDelete}                      
                        errorMessages={pageState.formServerErrors} onErrorbarClose={onErrorbarClose} onToolsToggle={onToolsToggle}
                        pageState={pageState}>
                          {
                            pageState.mode > 0 ? 
                              <DataSourcesPageForm onFieldRemove={props.onFieldRemove} onOpenFieldsDialog={props.onOpenFieldsDialog} onCloseFieldsDialog={props.onCloseFieldsDialog}
                                          onFieldCheck={props.onFieldCheck} onSaveFieldsDialog={props.onSaveFieldsDialog} 
                                          onFieldDragStart={props.onFieldDragStart} onFieldDragOver={props.onFieldDragOver} onFieldDrop={props.onFieldDrop}
                                          onFieldsClear={props.onFieldsClear} onFieldTitleChange={props.onFieldTitleChange} onFieldGroupingChange={props.onFieldGroupingChange}
                                          onOpenComputedFieldDialog={props.onOpenComputedFieldDialog} onValidateComputedFieldDialog={props.onValidateComputedFieldDialog} onSaveComputedFieldDialog={props.onSaveComputedFieldDialog} onCloseComputedFieldDialog={props.onCloseComputedFieldDialog}
                                          onOpenExpressionFieldDialog={props.onOpenExpressionFieldDialog} onValidateExpressionFieldDialog={props.onValidateExpressionFieldDialog} onSaveExpressionFieldDialog={props.onSaveExpressionFieldDialog} onCloseExpressionFieldDialog={props.onCloseExpressionFieldDialog}
                                          onFieldSortDirectionChange={props.onFieldSortDirectionChange}
                                          updateDirtyState={updateDirtyState}
                                          /> 
                              : <Fragment></Fragment>}
                    </Form>              
                }                
                {                  
                    currentTheme.pageHelpVisible && currentDatasetId > 0 &&
                     <HelpPage title="" items={helpItems} />
                }
                {                  
                    currentDatasetId == 0 &&
                    <IntroPage title={t("datasources.datasources")} items={introItems} />
                }
              </Splitter>
            }
              <style>
                {
                  `
                   .datasources-page > .content
                   {
                   } 

                        .datasources-page .k-splitter{
                      flex-direction:${
                        appearance.isRightToLeft ? "row-reverse" : "row"
                      } 
                    }
                      
                    .datasources-page .k-splitter .k-pane{
                      direction:${appearance.isRightToLeft ? "rtl" : "ltr"} 
                    }

                    .datasources-page .datasetview-page-wrapper{
                    border: ${currentTheme.pageFormBorder};   
                    height:100%; direction:${
                      appearance.isRightToLeft ? "rtl" : "ltr"
                    } 
                    
                    }  
                   
                    /*the manager*/
                    .datasources-page > .content .datasources-page-manager
                    {
                      border: ${currentTheme.managerBorder};
                      border-radius: ${currentTheme.pageBorderRadius};
                      background-color: ${currentTheme.componentBgFaded};
                    }

                    .datasources-page > .content .datasources-page-manager .k-dropdownlist
                    {
                      /*bg of datasets dropdown*/
                      background-color: transparent;
                      color: ${currentTheme.componentText};
                    }

                    .datasources-page > .content .datasources-page-manager .k-dropdownlist:focus
                    {
                        box-shadow: none;   
                    }

                    .datasources-page > .content .datasources-page-manager .panel-entities .k-input::placeholder
                    {
                        color: ${currentTheme.componentText};
                        /*font-style: italic;*/
                    }

                    .datasources-page > .content .datasources-page-manager .k-panelbar
                    {
                      background-color: transparent;
                    }

                    .datasources-page > .content .expressions-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link .k-icon
                    {
                      /*the arrow near every panel header*/
                      color: ${currentTheme.touchColor}!important;
                      margin-right: 6px;
                    }

                    .datasources-page > .content .datasources-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link
                    {
                      /*the span in the above <li> i.e. the title of every group in the manager: datasets, datasources, columns and description*/  
                      background-color: transparent;
                      color: ${currentTheme.touchColor};
                      border-bottom: 1px solid ${currentTheme.separatorColor}; 
                    }

                    .datasources-page > .content .datasources-page-manager ul li.k-panelbar-header.k-panelbar-item .k-link:hover
                    {
                      /*the above hovered - do nothing*/
                    }

                    .datasources-page > .content .datasources-page-manager .datasources .list-item:hover
                    {
                      /*expression item hover */
                      background-color: ${currentTheme.componentBorderColor};
                      cursor: pointer;
                    }

                    .datasources-page > .content .datasources-page-manager .dataset,
                    .datasources-page > .content .datasources-page-manager .description,
                    .datasources-page > .content .datasources-page-manager .k-child-animation-container
                    {
                      /*bg color of exp. manager elements */
                    }

                    .datasources-page > .content .datasources-page-manager .list-container
                    {
                      /*bg of both the exp. and columns Lists*/
                      background-color: transparent;
                      padding: 0;
                    }

                    .datasources-page > .content .datasources-page-manager .k-panelbar-header
                    {
                      background-color: transparent;
                    }

                    .datasources-page > .content .datasources-page-manager .k-panelbar-content
                    {
                      background-color: transparent;
                    }

                    .datasources-page > .content .datasources-page-manager .datasources .list-item-datasource-icon
                    {
                      /*first icon in datasources list*/
                      padding-left: 12px!important;
                    }

                    .datasources-page > .content .datasources-page-manager .datasources .list-item-datasource-icon
                    {
                      /*second icon in data sources list*/
                      padding: 5px 3px;                 
                    }

                    .datasources-page > .content .datasources-page-manager .datasources .list-item-title
                    {
                      vertical-align: middle;/*fine tuning*/
                    }               


                    /*the form*/
                    .datasources-page-form
                    {
                      background-color: transparent;
                      padding-left: 0px;
                      border: ${currentTheme.pageFormBorder};   
                      border-radius: ${currentTheme.pageBorderRadius};
                    }   

                    /*form toolbar*/
                    .datasources-page-form > .toolbar .k-toolbar
                    {
                        width: 100%;
                        border-left: none !important;
                        border-bottom: 1px solid ${currentTheme.separatorColor};
                        border-top: none !important;
                        border-right: none !important;
                        background-color: ${currentTheme.toolbarBg};/*transparent;*/
                        direction:${
                        appearance.isRightToLeft ? "row-reverse" : "row"
                      } 
                    }                    

                    .datasources-page > .content .toolbar .k-button
                    {
                      /*the toolbar buttons*/
                      border: none;
                      padding: 6px 8px;
                    }

                    .datasources-page > .content .toolbar .k-button-text
                    {
                      /*color of the text in every toolbar button=black in azure theme*/
                      color: ${currentTheme.toolbarText};
                    }

                    .datasources-page > .content .toolbar .k-button-icon
                    {
                      font-weight: 500;
                      color: ${currentTheme.primary};
                    }

                    .datasources-page > .content .form-root .content
                    {
                      background-color: ${currentTheme.pageContentBg};
                    }

                    /*styling the popup menu */
                    .k-popup ul{
                        padding: 0px;
                    }

                    .k-popup ul > li{
                        margin: 0;
                        padding: 0px;                                
                    }

                    .k-popup ul > li > span{
                        border: none !important;
                        box-shadow: none !important;
                    }

                    .k-menu-link{
                        padding: 0px 0px !important;                        
                    }

                    @media (max-width: 1024px) {
                      .datasources-page > .content {
                        overflow-y: auto;
                      }

                      .datasources-page > .content .k-splitter {
                        display: flex;
                        flex-direction: column !important;
                        height: auto !important;
                        overflow: visible;
                      }

                      .datasources-page > .content .k-splitbar {
                        display: none !important;
                      }

                      .datasources-page > .content .k-splitter > .k-pane {
                        flex: 0 0 auto !important;
                        width: 100% !important;
                        height: auto !important;
                        min-height: 0 !important;
                        min-width: 0 !important;
                        max-width: 100% !important;
                      }

                      .datasources-page > .content .k-pane:has(.help-page) {
                        display: none !important;
                      }

                      .datasources-page > .content .datasources-page-manager {
                        height: auto;
                        max-height: 45dvh;
                        margin-bottom: 12px;
                        overflow: auto;
                      }

                      .datasources-page > .content .datasources-page-manager .datasources .list-item-title {
                        flex: 1;
                        min-width: 0;
                        max-width: none;
                      }

                      .datasources-page > .content .datasources-page-form {
                        height: auto;
                        min-height: 0;
                        overflow: visible;
                      }

                      .datasources-page > .content .datasources-page-form > .toolbar .k-toolbar {
                        flex-wrap: wrap;
                        gap: 4px;
                        padding: 6px;
                      }

                      .datasources-page > .content .datasources-page-form > .toolbar {
                        display: none;
                      }

                      .datasources-page > .content .datasources-page-form > .content {
                        overflow: auto;
                        pointer-events: auto;
                        padding-bottom: calc(80px + env(safe-area-inset-bottom));
                        box-sizing: border-box;
                      }

                      .datasources-page > .content .datasources-page-form > .content input,
                      .datasources-page > .content .datasources-page-form > .content textarea,
                      .datasources-page > .content .datasources-page-form > .content button,
                      .datasources-page > .content .datasources-page-form > .content .k-dropdownlist,
                      .datasources-page > .content .datasources-page-form > .content .toggle-container,
                      .datasources-page > .content .datasources-page-form > .content .list-item,
                      .datasources-page > .content .datasources-page-form > .content .list-item-delete {
                        pointer-events: none;
                      }

                      .datasources-page > .content .datasources-page-form > .toolbar .k-separator {
                        display: none;
                      }

                      .datasources-page > .content .intro-page-wrapper {
                        height: auto;
                        min-height: 0;
                      }

                      .datasources-page > .content .intro-page {
                        overflow: visible;
                        padding: 8px;
                      }

                      .datasources-page > .content .intro-page > .item {
                        width: 50%;
                        padding: 16px 10px;
                        margin-top: 0;
                      }
                    }
                  `
                }
              </style>
            </Fragment>
    );
};
